import Handsontable from 'handsontable';

import { TableDataBase } from '../../types';
import createCellsMeta from './createCellsMeta';
import getColumnsForExport from './getColumnsForExport';
import prepareCellsMetadata from './prepareCellsMetadata';
import prepareTableData from './prepareTableData';

export default function exportBuildJson(
  ids: string[],
  columns: Handsontable.ColumnSettings[],
  tableData: TableDataBase[],
  hot: Handsontable,
  subtableColumnData?: string,
): string {
  const lut = [
    { bold: true }, // header
    { fontSize: 10 }, // subheader
    { format: 'default' },
    { format: 'numeric' },
    { format: 'datetime' },
  ];

  const columnsWithDecimalPlaces = withEffectiveDecimalPlaces(columns, hot);
  const columnsForExport = getColumnsForExport(columnsWithDecimalPlaces, subtableColumnData);
  const { columnWidths, columnTitles, columnDescriptions } = prepareCellsMetadata(columnsForExport, hot);
  const data = prepareTableData(
    ids,
    columnsWithDecimalPlaces,
    columnTitles,
    columnDescriptions,
    tableData,
    subtableColumnData,
  );
  const cellsMeta = createCellsMeta(data.length, columnsForExport);

  const pages = [
    {
      sheetSettings: {},
      sheetName: 'Sheet 1',
      metadata: { cells: cellsMeta, lut },
      data,
      columnWidths,
      rowHeights: [],
      images: [],
    },
  ];

  return JSON.stringify(pages);
}

export function withEffectiveDecimalPlaces(
  columns: Handsontable.ColumnSettings[],
  hot: Handsontable,
): Handsontable.ColumnSettings[] {
  if (hot.countRows() === 0) return columns;
  return columns.map((column) => {
    if (typeof column.data !== 'string') return column;
    const visualCol = hot.propToCol(column.data);
    if (typeof visualCol !== 'number' || visualCol < 0) return column;
    const { decimalPlaces } = hot.getCellMeta(0, visualCol) as { decimalPlaces?: unknown };
    if (typeof decimalPlaces !== 'number') return column;
    return { ...column, decimalPlaces };
  });
}
